<template>
<div class="php">
    <div class="photolist" v-loading="load">
        <div class="imgcon" v-for="(i,index) in photoList" :key="index">
            
            <el-image 
                style="width: 200px; height: 200px"
                :src="i.imgUrl" 
                fit="cover"
                :preview-src-list="[i.imgUrl]">
        </el-image>
        <div class="check" @click="check(index)"><i v-if="i.reviewState==2" class="el-icon-check"></i></div>
        </div>
         <div v-show="show" class="nonum">暂无数据</div>
    </div>
    <div class="opera">
         <el-select style="width:150px" @change="changeType" v-model="mztype" placeholder="请选择">
    <el-option
        
      v-for="item in mztypeList"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
    
  </el-select>
  <br/>
   <br/>
         <el-select @change="changePageSize" style="width:150px" v-model="pageSize" placeholder="请选择每页数量">
    <el-option
      v-for="item in options"
      :key="item.pageSize"
      :label="item.label"
      :value="item.pageSize">
    </el-option>
  </el-select>
  <br>
    
  <div class="num">总数:{{num}} 页数:{{pages}}</div>
  <div class="num">正在审核:{{shnum}} </div>
  <el-button type="success"  style="margin:20px 20px 20px 20px;" @click="pushItem(photoList,1)">提交 (下一页)</el-button>
  <br>
  <span class="his" @click="hisRecord">查看历史记录</span> 
    <!-- <el-button type="success">取消</el-button> -->
    </div>
<!-- diog -->
<div class="hiss">
<el-dialog title="历史记录" width="80%" :visible.sync="dialogTableVisible">
     <el-date-picker
      v-model="rangTime"
    type="datetimerange"
      value-format="yyyy-MM-dd HH:mm:ss"
      size="mini"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
    <el-select v-model="fhstatus" placeholder="请选择状态" size="mini">
    <el-option
      v-for="item in fhstatusList"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
   <el-button type="primary" size="mini" @click="serchHisRecord">查询</el-button>
  <el-table  ref="multipleTable"
    :data="gridData"
    tooltip-effect="dark"
    style="width: 100%"
     height="450"
    >
    <el-table-column property="reviewTime" label="日期" width="150"></el-table-column>
    <el-table-column property="reviewId" label="ID" width="150"></el-table-column>
    
    <el-table-column property="admin" label="账户" width="200"></el-table-column>
     <el-table-column label="照片">
      <template slot-scope="scope">
        <el-popover
            placement="right"
            title=""
            width="420"
            trigger="hover">
            <img :src="scope.row.imgUrl"/>
    <img slot="reference" :src="scope.row.imgUrl" :alt="scope.row.imgUrl" style="max-height: 100px;max-width: 100px">
   </el-popover>
    </template>
    </el-table-column>
    <el-table-column label="状态" width="300">
      <template slot-scope="scope">
      <el-switch
  style="display: block"
  v-model="scope.row.reviewState"
  active-color="#13ce66"
  :active-value="1"
  :inactive-value="2"
  inactive-color="#ff4949"
  active-text="审核通过"
  inactive-text="审核失败"
  @change="switchTab(scope.row)">
</el-switch>
    </template>
    </el-table-column>
  </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="1"
      :page-sizes="[10, 20, 50]"
      :page-size.sync="hispageSize"
      :current-page.sync="hisPage"
      layout="total, sizes, prev, pager, next, jumper"
      :total="hisNum">
    </el-pagination>
</el-dialog>
</div>
 
    </div>
</template>

<script>
    export default {
        data(){
            return{
                mztype:'1',
                mztypeList:[{
                    value:'1',
                    label:'民政'
                },{
                    value:'2',
                    label:'社保'
                }],
                shnum:0,
                hisPage:1,
                hispageSize:10,
                fhstatus:'',
                hisNum:0,
                fhstatusList:[{
                    value:'',
                    label:'所有'
                },{
                    value:1,
                    label:'审核通过'
                },{
                    value:2,
                    label:'审核失败'
                }],
                rangTime:'',
                status:true,
                PAGE:1,
                dialogTableVisible:false,
                gridData: [],
                load:false,
                page:0,
                url:"",
                num:'',
                pages:'',
                srcList: [],
                photoList:[],
                show:false,
                pageSize:'',
                options: [{
                pageSize: '20',
                label: '20张'
                },{
                pageSize: '50',
                label: '50张'
                },{
                pageSize: '100',
                label: '100张'
                },{
                pageSize: '200',
                label: '200张'
                },{
                pageSize: '300',
                label: '300张'
                }]
            }
        },
        methods:{
            changeType(){
               sessionStorage.setItem("status",this.mztype)
               this.getItem()
            },
            switchTab(s){
                this.$confirm('确认修改?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                    this.pushItem([s],2)
                    }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消修改'
                    }); 
                       this.serchHisRecord()   
                    });
                
            },
            serchHisRecord(){
                this.load=false
                console.log(this.hispageSize)
                let data={
                    reviewState:this.fhstatus,
                    startTime:this.rangTime[0],
                    endTime:this.rangTime[1],
                    pageNum:this.hisPage,
                    pageSize:this.hispageSize
                }
                this.$api.getlist.reviewhis(data).then(res=>{
                    this.gridData=res.data.list
                    this.hisNum=res.data.total
                }).catch(err=>{

                })

            },
            handleSizeChange(){
               this.serchHisRecord()
            },
            handleCurrentChange(){
                this.serchHisRecord()
            },
            check(index){                    
                     (this.photoList[index].reviewState!= 2)?(this.photoList[index].reviewState= 2):(this.photoList[index].reviewState= 1)        
            },
            changePageSize(){
                this.getItem()
            },
            getItem(){
            let data={
                pageNum:this.page,
                pageSize:this.pageSize?this.pageSize:20
            }
            this.load=true
            this.$api.getlist.reviewwaring(data).then((res) => {
                this.load=false
                this.photoList=[]
             
                if(res.code==200){
                    this.num=res.data.total
                    this.shnum=res.message
                    this.pages=res.data.totalPage
                    if(res.data.list.length==0){
                        this.show=true
                    }else{
                        this.show=false
                    }
                   res.data.list.forEach(ele => {
                        this.photoList.push({
                            imgUrl:ele.imgUrl,
                            recordId:ele.recordId,
                            reviewState:1,
                            id:ele.id
                        })
                    });
                }
              
                   
                    }).catch((res) => {
                         this.load=false 
                    });
                
                console.log(this.page)
            },
            pushItem(item,type){
                this.load=true
                this.$api.getlist.reviewpush(item).then(res=>{
                  console.log(res)
                    if(res.code==200){
                        this.$message("提交成功")
                        if(type==1){
                         this.getItem()
                         }else{
                         this.serchHisRecord()
                         }
                    }else{
                        this.$message(res.message)
                    }
                }).catch(err=>{

                })
               // this.getItem()
            },
            //查看历史记录
            hisRecord(){
                 this.serchHisRecord()
                this.dialogTableVisible=true
                
            },
            
        },
        created(){
            sessionStorage.setItem("status",'1')
            this.getItem()
        }
    }
</script>

<style>
.el-icon-circle-close{
    color: #fff;
}

.photolist{
    width: 85%;
}
.his{
    color: blue;
    cursor: pointer;
}
.opera{
    margin-top: 50px;
    position: fixed;
    top: 40%;
    margin: 0 auto;
    right: 0%;
    text-align: center;
    background: #fff;
    border: 1px solid lightgray;
    border-radius: 10px;
    padding: 10px;
}
.photolist .imgcon{
    width: 200px;
    height: 200px;
    margin: 10px;
    position: relative;
}
.nonum{
    font-weight: bolder;
    text-align: center;
    font-size: 30px;
    padding: 50px 0 0 0;
    color: gray;
    width:100%
}
.num{
    margin-top: 20px;
    
}
.imgcon img{
    width: 100%;
    height: 100%;
}
.el-image-viewer__canvas img{
    width:40%;
    height: auto;
}
.photolist{
    display: flex;
    flex-wrap: wrap;
}
.php .el-image__inner{
    height: 100% !important;
}
.check{
    position: absolute;
    top: 5px;
    right: 5px;
    width: 20px;
    z-index:400;
    height: 20px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 25px;
    font-weight: bolder;
    color: red;
    cursor: pointer;
    background: #ffffff;
    border: 2px solid rgb(177, 176, 176);
    border-radius: 3px;
}

</style>


// WEBPACK FOOTER //
// src/views/Myvue/photoList.vue